import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ChangeFactoryDirectTruckloadDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog && this.props.handleDialog('changeFactoryDirectTruckloadDialog', false);
    }
    componentDidMount() {
        // window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="ChangeShippingMethodAdcBoxTruck">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Action</h2>
                    <p><b>Factory Direct orders cannot be under 112
                    points or over 126 points and are limited to
                    no more than 10 products</b></p>
                    <p><b>Please adjust the items or quantities</b></p>
                  
                    {<div className="yesButtonContainer">
                         <a className="yesButton blueButton" onClick={(e) => this.props.continueFactoryDirectTruckload(e)}>Ok</a>
                    </div>}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {state};
};

ChangeFactoryDirectTruckloadDialog = connect(mapStateToProps)(ChangeFactoryDirectTruckloadDialog);
export default ChangeFactoryDirectTruckloadDialog;


// WEBPACK FOOTER //
// ./src/App/components/dialogs/changeFactoryDirectTruckloadDialog.js